import { createSlice } from "@reduxjs/toolkit";
import { apiAdminSlice } from "../../Services/admin/api.admin.slice";
import { saveAdminToken, removeAdminToken } from "../../Utils/tokenStorage";

type AdminType = {
    token?: any;
    email?: string;
    isAuthenticated: boolean
};

type InitialStateType = {
    adminAuth: AdminType | null;
};

const initialState: InitialStateType = {
    adminAuth: {
        isAuthenticated: false
    }
};

const adminAuthReducer = createSlice({
    name: "adminAuth",
    initialState,
    reducers: {
        loginSuccess: (state: InitialStateType, action) => {
            state.adminAuth = {
                ...action.payload,
                isAuthenticated: true
            };
            saveAdminToken(action.payload.token);
            return state;
        },
        logout: (state: InitialStateType) => {
            removeAdminToken();
            return state;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(apiAdminSlice.endpoints.adminLogin.matchFulfilled, (state, action) => {
            const { data } = action.payload
            state = { ...data };
            saveAdminToken(data.token);
            return state;
        })
    },
});

export const { loginSuccess, logout } = adminAuthReducer.actions;
export default adminAuthReducer.reducer;


// export const { setTogglePropertyClaimedModal } = propertyReducer.actions;
// export default propertyReducer.reducer;
